module.exports = __webpack_public_path__ + "img/1c7622e20912bb69b32cd24d9e353053.png";